import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {reaction} from "mobx";

interface SessionTimerValueComponentProps {
    renderValue: (value: string) => React.ReactElement;
}

export const SessionTimerValueComponent: React.FC<SessionTimerValueComponentProps> = observer((props) => {
    const services = useServices();
    const [sessionTimer, setSessionTimer] = useState(services.sessionTimer.currentSessionTimer);

    useEffect(() => {
        const r = reaction(() => services.sessionTimer.currentSessionTimer,
            (currentSessionTimer) => {
                if(services.sessionTimer.isEnabled && sessionTimer.totalMinutes !== currentSessionTimer.totalMinutes) {
                    setSessionTimer(currentSessionTimer);
                }
            }, {
                fireImmediately: true
            });

        return () => r();

    }, [sessionTimer, services.sessionTimer.currentSessionTimer, services.sessionTimer.isEnabled]);

    const hours = Math.floor(sessionTimer.totalHours);
    const minutes = sessionTimer.minutes;

    return props.renderValue(`${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')}`);

})